import { Injectable } from '@angular/core';

import { Api } from '../api/api';
import { User } from '../user/user';

@Injectable()
export class Services {

  constructor(
    private api: Api,
    private user: User
  ){}

  tratCallback(res:any,callback:any){
    // console.log(res);
    if(res.status){
      callback({status:true,data:res.data})
    }else{
      callback({status:false,msg:res.error})
    }
  }

  getData(base:any,filter:any,callback:any){
    var endpoint = ['api2',this.user.getSession(),'get',base].join('/');
    if(!filter){
      this.api.request('get',endpoint,{},{},(res)=>this.tratCallback({status:true,data:res},callback));
    }else{
      filter.removerApiKey = true;
      this.api.request('post',endpoint,filter,{},(res)=>this.tratCallback({status:true,data:res},callback));
    }
  }

  forgot(base:any,filter:any,callback:any){
    var endpoint = 'ws/api/tracking/enviaremail';
    this.api.request('post',endpoint,filter,{},(res)=>this.tratCallback({status:true,data:res},callback));
  }

  save(base:any,obj:any,callback:any){
    var endpoint = ['api2',this.user.getSession(),'operacs',base].join('/');
    if(!obj['_id']){
      this.api.request('post',endpoint,obj,{},(res)=>this.tratCallback({status:true,data:res},callback));
    }else{
      this.api.request('put',endpoint,obj,{},(res)=>this.tratCallback({status:true,data:res},callback));
    }
  }

  saveImg(base:any,obj:any,callback:any){
    var endpoint = ['gridfs',this.user.getSession(),'upload64'].join('/');
    this.api.request('post',endpoint,obj,{},(res)=>this.tratCallback({status:true,data:res},callback));
  }

  download(link:any,callback:any){
    this.api.request('download',link,{},{},(res)=>this.tratCallback({status:true,data:res},callback));
  }

  master(tipo:any,obj:any,callback:any){
    var endpoint = ['api2',this.user.getSession(),'master',tipo].join('/');
    this.api.request('put',endpoint,obj,{},(res)=>this.tratCallback({status:true,data:res},callback));
  }

  insertAll(base:any,objs:any,callback:any){
    var endpoint = ['api2',this.user.getSession(),'operacs',base].join('/');
    this.api.request('post',endpoint,objs,{},(res)=>this.tratCallback({status:true,data:res},callback));
  }

  saveAll(base:any,objs:any,callback:any){
    var endpoint = ['api2',this.user.getSession(),'operacs',base].join('/');
    this.api.request('put',endpoint,objs,{},(res)=>this.tratCallback({status:true,data:res},callback));
  }
}



// WEBPACK FOOTER //
// ./src/providers/services/services.ts